export const REDIRECT_URL = 'https://vault.apideck.com/oauth/callback';
export const BASE_URL = `https://unify.apideck.com`;
